const type = 'START_CUSTOMERS_FETCHING';

const startCustomersFetching = () => ({
  type,
});

export { type };
export default startCustomersFetching;
